import React from 'react';
import ComingSoon from '../components/ComingSoon';
import './PageStyles.scss';

const Attendance: React.FC = () => {
  return (
    <div className="hr-portal-page">
      <div className="hr-portal-page-header">
        <h2>Attendance</h2>
        <p className="page-description">Track and manage employee attendance records</p>
      </div>
      <div className="hr-portal-page-content">
        <ComingSoon title="Coming Soon" />
      </div>
    </div>
  );
};

export default Attendance;
